import type Changes from 'modules/bookkeepers/store/collections/changes'

export interface CostCenter {
  id: number
  cost_center_id: number
  cost_center: string
  end_date?: string
  percentage: number
}

export const changesToCostCenters = (changes: Changes): CostCenter[] =>
  changes.map((change) => {
    return {
      id: change.attributes.id,
      cost_center_id: change.attributes.cost_center_id,
      cost_center: change.attributes.cost_center,
      end_date: change.attributes.end_date,
      percentage: change.attributes.percentage,
    }
  })

export const costCenterPercentageToString = (costCenter?: CostCenter): string =>
  costCenter ? `${(costCenter.percentage * 100).toFixed(2)}%` : '0%'
